import { render, staticRenderFns } from "./DeEditor.vue?vue&type=template&id=4ed4f649&scoped=true&"
import script from "./DeEditor.vue?vue&type=script&lang=js&"
export * from "./DeEditor.vue?vue&type=script&lang=js&"
import style0 from "./DeEditor.vue?vue&type=style&index=0&id=4ed4f649&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed4f649",
  null
  
)

export default component.exports